<template>
  <v-list dense>
    <v-list-item v-for="(col, index) in handleFilterItems[0]" :key="index">
      <v-list-item-content>
        <v-list-item-title>{{ index }}:</v-list-item-title>
      </v-list-item-content>

      <v-list-item-content class="align-end text-right" :title="col">
        <v-list-item-subtitle>{{ typeof col === 'string' && col.length >= 30 ? doTruncateText(col, 30) : col }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { doTruncateText } from '@/helpers/utils';

export default {
  props: {
    model: { type: [Object, Array], default: () => ({}) },
    headers: { type: Array, default: () => [] }
  },

  computed: {
    handleFilterItems() {
      const item = [];

      item.push(this.model);

      return item.map(item => {
        return this.headers.reduce((obj, { text, value }) => {
          if (value === 'action') return;

          return {
            ...obj,
            [text]: item[value]
          };
        }, {});
      });
    }
  },

  methods: {
    doTruncateText
  }
};
</script>
